import { useState } from 'react'
import { Button } from '@mui/material'

import { GenerateModal, HelperWrapper } from 'src/components'
import { AIGenerateContentPrompt } from 'src/types'

import { useStyles } from './styles'

interface IGenerateAIButtonProps {
  setGeneratedValue: (value: string) => void
  generationType: AIGenerateContentPrompt
  textPrompt?: string
  isDisabled?: boolean
  locale?: string
  iSIndentTop?: boolean
}

const GenerateAIButton = ({
  setGeneratedValue,
  generationType,
  textPrompt,
  isDisabled,
  locale,
  iSIndentTop = false,
}: IGenerateAIButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const classes = useStyles()

  const handleModalToggle = () => {
    setIsOpen((toggle) => !toggle)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleAddition = (value: string) => {
    setGeneratedValue(value)
    handleClose()
  }

  return (
    <>
      <Button
        disabled={isDisabled}
        variant="text"
        onClick={handleModalToggle}
        className={classes.button}
        type="button"
        size="small"
        sx={{ marginTop: iSIndentTop ? '5px' : 0 }}
      >
        <HelperWrapper t="ai-generate-button-text" isColorInherited />
      </Button>
      <GenerateModal
        locale={locale}
        textPrompt={textPrompt}
        generationType={generationType}
        handleAddition={handleAddition}
        handleClose={handleClose}
        isOpen={isOpen}
      />
    </>
  )
}

export { GenerateAIButton }
